import { twMerge } from "tailwind-merge";
import { useApp } from "../../../services/app-context";
import { getPerformanceColor } from "../../../services/utils";


export function PerformanceView({
  title,
  value,
  titleClassName,
}: {
  title: string;
  value: number;  
  titleClassName?: string;
}) {
  const { tenantProfile } = useApp();
  const metric_ranges = tenantProfile?.metric_ranges || [];
  let color = getPerformanceColor(value, metric_ranges || []);

  return (
    <div>
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div className={twMerge("text-[#1E1E1E] text-sm capitalize", titleClassName)}>{title}</div>
        <div className={`hidden md:block text-base font-bold`} style={{ color: color.text }}>
          {value}%
        </div>
      </div>
      <div className="flex items-center gap-2 mt-1.5">
        <div
          className={`flex-1 flex-1 h-[9px] overflow-hidden rounded-full`}
          style={{ backgroundColor: color.progressBg }}
        >
          <div
            className={`h-[9px] rounded-full`}
            style={{
              width: `${value || 0}%`,
              backgroundColor: color.progress,
            }}
          />
        </div>
        <div className={`md:hidden text-[clamp(13px, 1.5vw, 16px)] font-semibold`} style={{ color: color.text }}>
          {value}%
        </div>
      </div>
    </div>
  );
}
